export default "__VITE_ASSET__BlF3AXWt__"